module.exports = __webpack_public_path__ + "media/images/favicon/apple-touch-icon-120x120-6ab4cca27f0de9b341c8b9fa499d8038.png";